import { assign, map } from 'lodash';
import { PersonType } from 'common/common/constants/person-type.enum';
/**
 * OutgoingChatMessage model
 * @param OutgoingChatMessage
 *  <fields>
 <field name="ChatMessageID"              type="long" />
 <field name="PersonType"                 type="byte" />
 <field name="PersonID"                   type="long"/>
 <field name="CannedMessageID"            type="long"/>
 <field name="Name"                       type="text" size="30"/>
 <field name="Text"                       type="text"/>
 <field name="ChatID"                     type="long"/>
 </fields>
 *
 * @constructor
 */

// WTF

export class OutgoingChatMessage {
  public ChatMessageID: string;
  public PersonType: PersonType;
  public PersonID: string;
  public CannedMessageID: string;
  public Name: string;
  public Text: string;
  public ChatID: string;

  static wrap(event) {
    return new OutgoingChatMessage(event.data);
  }

  static wrapAll(eventList) {
    return map(eventList, OutgoingChatMessage.wrap);
  }

  constructor(message) {
    // let ChatID = 0;
    // let ChatMessageID = '';
    // let PersonType = 0; // required byte
    // let PersonID = 0; // required Long
    //
    // let CannedMessageID = 0; //optional Long
    // let Name = ''; // optional string
    // let Text = ''; // optional string
    // let ClearIsTyping = true; // optional boolean

    assign(this, message);
  }
}

export function factory() {
  return OutgoingChatMessage;
}
